export default "__VITE_ASSET__BW1yHMp8__"